import { Injectable } from '@angular/core';
import { ParamMap } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { isNil, cloneDeep } from 'lodash-es';
import { ToastrService } from 'ngx-toastr';

import { WavelengthShellService } from 'wavelength-ui';
import { EModalSize, EToasterType, EToasterPosition } from 'wavelength-ui';


import { app_homeComponent } from './app.home.component';

import { FootprintApiManager_ShellService } from './FootprintApiManager.shell.service';
import { SPSCommerce_ShellService } from './SPSCommerce.shell.service';

@Injectable({ providedIn: 'root' })
export class app_ShellService extends WavelengthShellService  {
  constructor(
    dialog : MatDialog,
    toastr: ToastrService,
    public FootprintApiManager: FootprintApiManager_ShellService,
    public SPSCommerce: SPSCommerce_ShellService,
  ) {
    super(dialog, toastr);
  }

  public app: app_ShellService = this;

  public openhome(replaceCurrentView?: boolean) {
    WavelengthShellService.openViewRequest$.next(
      {
        title: 'SPS Commerce Api',
        referenceName: 'home',
        component: app_homeComponent,
        replaceCurrentView: replaceCurrentView,
        
      }
    );
  }

  public openhomeDialog(
    
    mode: 'modal' | 'flyout' = 'modal',
    size?: EModalSize
  ): Promise<void> {
    let dialogSize;
    if (size) {
      dialogSize = size; 
    } else {
      dialogSize = EModalSize.Standard;
    }

    return this.openDialog(
      app_homeComponent,
      'SPS Commerce Api',
      mode,
      dialogSize
    )
  }

  public override getComponentInformation(referenceName: string, params: ParamMap): { title: string, component: any, inParams: any } {
    if (referenceName === 'home') {
      const title = 'SPS Commerce Api';
      const component = app_homeComponent;
      const inParams = null;

      return { title: title, component: component, inParams: inParams };
    }


    let result = null;
    result = this.FootprintApiManager.getComponentInformation(referenceName, params);
    if (result) {
      return result;
    }
    result = this.SPSCommerce.getComponentInformation(referenceName, params);
    if (result) {
      return result;
    }
    return result;
  }
}
